var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FilterOrganization',{attrs:{"disable":true,"option":_vm.option},on:{"option":_vm.onOptionChange}}),_c('ManagementAccountHistory',{attrs:{"caption":"Accounts","icon":"cil-user","item":_vm.accounts,"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }